import { getSessionId } from "@/utils/sessionId";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || "",
  timeout: 10000, // Set a timeout (in milliseconds)
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Tag every BFF request with the per-tab session id (browser only) so
// server-side usage logging in the proxies can correlate requests.
axiosInstance.interceptors.request.use((config) => {
  const sessionId = getSessionId();
  if (sessionId) config.headers["x-session-id"] = sessionId;
  return config;
});

export const axiosApiInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_MINCH_API_URL || "",
  timeout: 10000, // Set a timeout (in milliseconds)
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Request logging
axiosApiInstance.interceptors.request.use((config) => {
  console.log(
    "🥓 [Axios] Request:",
    config.method?.toUpperCase(),
    (config.baseURL as string) + config.url
  );
  console.log("Headers:", config.headers);
  if (config.data) console.log("Payload:", config.data);
  return config;
});

// Response logging
axiosApiInstance.interceptors.response.use(
  (response) => {
    console.log("✅ [Axios] Response:", response.status, response.config.url);
    return response;
  },
  (error) => {
    if (error.response) {
      console.log(
        "❌ [Axios] Error:",
        error.response.status,
        error.config?.url
      );
    } else {
      console.log("❌ [Axios] Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
